import React from 'react';

export default function ToolsImage(props?: SVGProps) {
	return (
		<svg
			viewBox='0 0 24 24'
			strokeWidth='1.5'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}>
			<path
				d='M10.0503 10.6066L2.97923 17.6777C2.19818 18.4587 2.19818 19.7251 2.97923 20.5061V20.5061C3.76027 21.2872 5.0266 21.2872 5.80765 20.5061L12.8787 13.4351'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
			<path
				d='M17.1927 13.7994L21.071 17.6777C21.8521 18.4587 21.8521 19.7251 21.071 20.5061V20.5061C20.29 21.2872 19.0236 21.2872 18.2426 20.5061L12.0341 14.2977'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
			<path
				d='M6.73267 5.90381L4.61135 6.61092L2.49003 3.07539L3.90424 1.66117L7.43978 3.78249L6.73267 5.90381ZM6.73267 5.90381L9.5629 8.73404'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
			<path
				d='M10.0503 10.6066C9.2065 8.45359 9.37147 5.62861 11.111 3.8891C12.8505 2.14958 16.0607 1.76778 17.8285 2.82844L14.7878 5.86911L14.5052 8.98015L17.6162 8.69754L20.6569 5.65686C21.7176 7.42463 21.3358 10.6349 19.5963 12.3744C17.8567 14.1139 15.0318 14.2789 12.8788 13.435'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
		</svg>
	);
}
